import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopGeidea = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const Features = [
        {
            id: 1,
            image: "/assets/GeideaPayments/payment.svg",
            title: "Multiple Payment Methods",
            desc: "Offer unparalleled convenience to your customers with a wide variety of payment options, ensuring flexibility and ease at checkout. With Geidea Payment Gateway integrated into QueueBuster POS, you can accept multiple payment methods, including credit and debit cards, UPI, mobile wallets, and net banking. ",
            bgColor: "#8ae4f626",
            imageHeight: "42rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            imageWidth: "40rem",
            tagColor: "#C9F6FF",
            points: [
                "Accepts credit/debit cards, UPI, mobile wallets, and more.",
                "Fully integrated with popular digital payment platforms.",
                "Allows contactless payments for faster, safer transactions.",

                
            ]
        },
        {
            id: 2,
            image: "/assets/GeideaPayments/transaction.svg",
            title: "Transaction Processing and Reporting",
            desc: "Ensure that every transaction is processed and reflected instantly, offering you real-time insights and updates for better business management. With the Geidea Payment Gateway integrated into QueueBuster POS, transactions are swiftly completed, and the results—whether successful or failed—are immediately visible across all connected platforms.",
            bgColor: "#F2FDEB",
            imageHeight: "32rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Immediate transaction processing for all payment types.",
                "Real-time sales, revenue, and refund reports are accessible anytime.",
                "Streamlined data updates across multiple locations for accuracy."
            ]
               
        },
        {
            id: 3,
            image: "/assets/GeideaPayments/refund.svg",
            title: "Refund and Dispute Management",
            desc: "Simplify the process of handling refunds and disputes with ease, ensuring a seamless experience that keeps your customers satisfied. With the Geidea Payment Gateway integrated into QueueBuster POS, initiating refunds is straightforward and can be done directly from the POS system, reducing wait times and improving customer service. Real time tracking allows you to monitor the status of refunds, keeping you informed at every step.",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
                "Initiate refunds directly from the POS system.",
                "Track refund statuses in real time, reducing manual followups.",
               " Builtin dispute resolution tools to efficiently manage chargebacks.",
               
            ]
        },
        {
            id: 4,
            image: "/assets/GeideaPayments/offline.svg",
            title: "Offline Payment Processing ",
            desc: "Keep your business running smoothly, even during internet outages, with the robust offline transaction support offered by Geidea Payment Gateway integrated with QueueBuster POS. This feature ensures that your business never has to come to a halt due to connectivity issues. When the internet is down, the system securely stores all transaction data locally, allowing you to continue processing payments without any interruptions. ",
            bgColor: "#8ae4f626",
            imageHeight: "55rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                "Safely stores transactions offline and syncs once the connection is restored.",
               " Supports all payment methods while offline, ensuring uninterrupted service.",
               " Reduces downtime and potential sales loss during connectivity issues.",
               
            ]
        },
    ]

    const FAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                   What is Geidea Payment Gateway, and how does it integrate with QueueBuster POS?
                </span>
            ),
            des: "Geidea Payment Gateway is an efficient and secure payment processing solution that supports multiple payment methods such as credit/debit cards, UPI, mobile wallets, and net banking. Further, integrated with QueueBuster POS, it enables companies to handle the processing of all types of payments through one interface easily. This will ensure speed of transaction and realtime synchronization of the data. It adds value to QueueBuster POS with safe, efficient, and flexible payment solutions that smoothen your operations and take care of everything, right from sales up to refunds.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What payment methods does Geidea Payment Gateway integrate into QueueBuster POS support?
                </span>
            ),
            des:[
                <>
                 <>Integrating the Geidea Payment Gateway into QueueBuster POS will let you offer your customers a range of options to pay: <br /></>
                    <>
                        <> <b>Credit and Debit Cards:</b> You can support Visa, MasterCard, American Express, and more. <br /></>
                        <><b>UPI:</b> Support faster and contactless payments using UPI. <br /></>
                        <><b>Mobile Wallets:</b> Allow them to make payments using popular mobile wallets such as Paytm, Google Pay, PhonePe, and more. <br /></>
                        <> <b>Net Banking:</b> Let their accounts directly transfer money from their accounts.</>
                    </>
                </>
            ],
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the realtime transaction processing and reporting work with Geidea and QueueBuster POS integration?
                </span>
            ),
            des: "The realtime transaction processing means that every payment coming through the Geidea Payment Gateway instantaneously gets processed and is reflected in QueueBuster POS. Immediately after every sale or refund, the transaction will automatically update your POS system so that you will be able to see the realtime data of each transaction. Therefore, this will let the owner of the company make prudent decisions since he will have an updated view on the company's financial health. Additionally, you can receive immediate reports on sales, revenues, refunds, and transaction statusesall very relevant and helpful for running businesses effectively.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is it possible to manage refunds and disputes directly from the QueueBuster POS system?
                </span>
            ),
            des: "Yes, it is quite easy to handle refunds/disputes as the Geidea Payment Gateway is integrated into QueueBuster POS. Refunds can be initiated directly from the POS, so it's pretty easy and fast. The system also allows for the tracking of the refund request status in real time, so that you can monitor the progress and minimize phone followups. More importantly, QueueBuster POS offers dispute resolution tools for effectively managing chargebacks and disputes while keeping your customers satisfied, with full transparency about the transaction.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What happens if my internet connection goes down? Am I able to process the payments using QueueBuster POS and Geidea Payment Gateway?
                </span>
            ),
            des: "Yes, you can still process the continuation of payments even on an internet outage. QueueBuster POS integrated with Geidea Payment Gateway facilitates the offline processing of payments. In case the internet is down, all transaction data is stored securely locally in the system. When the connection comes back, all the stored transactions will automatically be processed and synchronized with the Central System. This feature keeps your business running uninterrupted, therefore minimizing sales loss and assuring the smooth experience of your customers even when it's offline.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                   Is the Geidea Payment Gateway integration with QueueBuster POS secure?
                </span>
            ),
            des: "In this regard, the integration between Geidea Payment Gateway and QueueBuster POS should be in conformance with the highest standards of security, including compliance with PCIDSS. That is, it means all transactions are encrypted and processed in a very secure manner to protect sensitive information about your customers. Besides that, Geidea allows for advanced fraud detection, underpinning realtime monitoring of transactions for anomalies to further secure your business and customers' data.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the integration make multilocation management easy?                     
                </span>
            ),
            des: "Geidea Payment Gateway provides a centralized management view in QueueBuster POS for companies with several outlets. It also allows the sharing of data in realtime across all its outlets, thereby making sure that every change in a transaction detail would happen instantly and be viewed on one screen. It helps you to drive sales, monitor refunds, and access reports for each outlet on a single screen or panel. You can make quick decisions and ensure more accuracy in your operations with easier updates of data across the various outlets.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                How easy is it to set up and use the Geidea Payment Gateway with QueueBuster POS?
                </span>
            ),
            des: "Quite easy and hasslefree, setting up a Geidea Payment Gateway on QueueBuster POS. Once set up, any payment integrations are ready for use. QueueBuster POS gives you a stepbystep setup, and the interface is intuitive enough to have you running around in no time. It is an integration designed to be smooth, and one wouldn't have to invest a lot of time in technical knowhow just to get up and running. Customer support at QueueBuster will present itself for any difficulties and assist on points of configuration or troubleshooting.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does realtime reporting help my business?
                </span>
            ),
            des: "Meanwhile, realtime reporting provides insight into the financial health of your business at any given time through sales, refunds, and revenue. It helps you make more knowledgeable decisions by offering insights into performance tracking across various locations and highlighting trends and further opportunities for growth. In addition, responding to issues or discrepancies with swiftness is easier when information is provided in real time, thus shrinking potential losses. This will also ensure better operational efficiency. Automated reporting cuts down on manual tasks, which saves time and eliminates human error.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Will QueueBuster POS allow me to customize my payment options and features with Geidea Payment Gateway?
                </span>
            ),
            des: "Yes, QueueBuster POS gives you full independence to engage your choice of payment options on or off. You can turn any form of payment method on or off depending upon customer suitability, which may be through credit cards, UPI, or mobile wallets. You can also customize checkout to ensure a smooth and seamless experience for your customers. And the ability to turn on or off whatever features you need ensures you can remain competitive while keeping operations aligned with your business model. ",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/GeideaPayments/Geidea_logo.svg" alt="GSP" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Geidea Payment Integration</span><br />
                        <span className={styles.black_text}>with</span><span className={styles.blue_text}> QueueBuster POS</span>
                    </h1>
                    <p className={styles.page_desc}> Experience seamless and secure transactions with the Geidea Payment Gateway, now fully integrated into QueueBuster POS. Whether you're managing a retail shop, café, or any other business, our solution provides multiple payment options, realtime processing, and robust refund management—all while functioning even without an internet connection.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "38rem" }}><Image src="/assets/GeideaPayments/Geidea.svg" alt="geodea" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3> Key Features of Geidea Payment Gateway Integrated with QueueBuster POS</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>

                <HardwareFeatures features={Features} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={FAQ} heading={"FAQs for Geidea Payment Gateway Integrated with QueueBuster POS"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopGeidea